export default __webpack_public_path__ + "static/media/certificado_valid_icon.a7b3da9c.svg";